// extracted by mini-css-extract-plugin
export default {"panelHeader":"SettingsPanelHeader_panelHeader__OY6m1","headerText":"SettingsPanelHeader_headerText__LYh58","rightSlot":"SettingsPanelHeader_rightSlot__3q1h2"};